import type { RouteRecordRaw } from 'vue-router'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    meta: {
      layout: 'auth',
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/pages/auth/Login'),
      },
      {
        path: 'verification/:code',
        name: 'verification',
        component: () => import('@/pages/auth/Verification'),
      },
    ],
  },
]
